function Locale (props) {
	this.key = props.key;
	
	props.isDirty = false;
	props.deleted = ("deleted_at" in props && props.deleted_at !== null && props.deleted_at !== false);
	this.props = props;
	return this;
}

Locale.modelName = 'locales';

export default Locale;


// WEBPACK FOOTER //
// ./src/Entities/Locale.js